import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { MainAnalyticsStore } from './main-analytics.store';

const MainAnalyticsContext = React.createContext<MainAnalyticsStore | null>(null);

export const MainAnalyticsProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<MainAnalyticsStore>(() => new MainAnalyticsStore(navigate));

   return (
      <MainAnalyticsContext.Provider value={store}>{children}</MainAnalyticsContext.Provider>
   );
};

export const useMainAnalytics = () => {
   const ctx = React.useContext(MainAnalyticsContext);
   if (!ctx) {
      throw new Error('useMainAnalytics must be used inside MainAnalyticsProvider');
   }
   return ctx;
};
